import * as yup from 'yup'
import { baseInput } from './BaseInput.schema'

export const baseTextInput = yup
	.object({
		value: yup.string().default(''),
	})
	.concat(baseInput)
